import { createContext, useContext } from 'react';
import type { AssistantModalTheme } from './theme';

const ModalThemeContext = createContext<AssistantModalTheme>('light');

export const ModalThemeProvider = ModalThemeContext.Provider;
export const useModalTheme = () => useContext(ModalThemeContext);
